import React, { useCallback, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthRoutes, GuestRoutes } from './AppRoutes';
import { StateProfile } from '@src/utils/state-profile';
//@ts-ignore

import { getGuest } from '@src/utils/state-guest';
import App from '@src/App';
import { useAuth } from '@src/context/AuthContext';
import { IProfile } from '@src/types';
import { useTokenHandler } from '@src/hooks/use-token-handler';
import { useTokenExpiration } from '@src/hooks/use-token-expiration';

interface AuthResponse {
    firstName: string;
    lastName: string;
    email: string;
    profileImgId?: string;
    image?: string;
    authType: string;
    id: string;
    tel?: string;
    role: 'MEMBER' | 'EVENT_MANAGER' | 'PROJECT_OWNER' | 'ADMIN';
}


const redirectByRole = (role: AuthResponse['role']): void => {
    const roleRoutes = {
        MEMBER: '/',
        EVENT_MANAGER: '/manage-locations',
        PROJECT_OWNER: '/admin/project',
        ADMIN: '/admin'
    } as const;

    const targetRoute = roleRoutes[role] || '/admin';

    window.location.href = targetRoute;
};

export const RouterContent = () => {

    const { setIsAuthenticated } = useAuth();
    const isTokenExpired = useTokenExpiration();
    const isGuest = getGuest();


    const urlParams = useMemo(() => new URLSearchParams(window.location.search), []);
    const rttokenParam = useMemo(() => urlParams.get('rttoken'), [urlParams]);


    const handleTokenSuccess = useCallback((response: AuthResponse) => {
        setIsAuthenticated(true);

        const userProfile: IProfile = {
            firstName: response.firstName,
            lastName: response.lastName,
            email: response.email,
            authType: response.authType,
            mapId: response.id,
            mobile: response.tel,
        };

        StateProfile(userProfile);

        redirectByRole(response.role);
    }, [setIsAuthenticated]);

    const { isProcessing, error } = useTokenHandler({
        token: rttokenParam,
        onSuccess: handleTokenSuccess,
        onError: (error) => {
            console.error('Token processing failed:', error);
        }
    });
    if (isProcessing) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-red-600">Authentication failed. Please try again.</div>
            </div>
        );
    }

    // useEffect(() => {
    //     const fetchRttoken = async (token: string) => {
    //         try {
    //             const payload = decodeJwt(token);
    //             const date = new Date(0);
    //             date.setUTCSeconds(payload.exp);
    //             document.cookie = `zero-carbon-auth.session-token=${token}; path=/; expires=${date.toUTCString()};`;

    //             const response = await authGeneralTokenAPI(token);
    //             if (response) {
    //                 setIsAuthenticated(true);
    //                 let stateSaveProfile = {
    //                     firstName: response?.firstName,
    //                     lastName: response?.lastName,
    //                     email: response?.email,
    //                     profileImgId: response?.profileImgId,
    //                     image: response?.image,
    //                     authType: response?.authType,
    //                     mapId: response?.id,
    //                     mobile: response?.tel,
    //                 };

    //                 StateProfile(stateSaveProfile);

    //                 if (response.role === 'MEMBER') {
    //                     window.location.href = '/';
    //                 } else if (response.role === 'EVENT_MANAGER') {
    //                     window.location.href = '/manage-locations';
    //                 } else if (response.role === 'PROJECT_OWNER') {
    //                     window.location.href = '/admin/project';
    //                 } else {
    //                     window.location.href = '/admin';
    //                 }
    //             }
    //         } catch (error) {
    //             console.error('Error fetching token:', error);
    //             // Handle error appropriately
    //         }
    //     };

    //     if (rttokenParam && rttokenParam.length > 100) {
    //         fetchRttoken(rttokenParam);
    //     }
    // }, [rttokenParam, setIsAuthenticated]);
    if (isGuest) return <GuestRoutes />;
    if (isTokenExpired) return <AuthRoutes />;
    return <App />;
    // return <BrowserRouter>{isGuest ? <GuestRoutes /> : isTokenExpired ? <AuthRoutes /> : <App />}</BrowserRouter>;
};

export const ManageAccessRouter: React.FC = () => {
    return (
        <BrowserRouter>
            <RouterContent />
        </BrowserRouter>
    );
};
